import React from 'react';
import { Loader2 } from 'lucide-react';

export const LoadingScreen: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 to-gray-800 flex items-center justify-center">
      <div className="text-center">
        <img src="/logo.webp" alt="Level Up Classroom" className="w-full max-w-md mx-auto mb-6" style={{ aspectRatio: '3/2' }} />
        <Loader2 size={32} className="animate-spin text-blue-500 mx-auto mb-4" />
        <p className="text-white/70">Loading Level Up Classroom...</p>
      </div>
    </div>
  );
};